import styled from "@emotion/styled";
import * as React from "react";
import { LocalDateTime, VisitInstanceId } from "../messages";
import { PLAY_ICON, SQUARE_ICON } from "../utils/svgs_new";
import ClockHour from "./ClockHour";
import { AppButton } from "./Generic/AppButton";
import { AppCard, AppCardContent } from "./Generic/AppCard";
import { AppIcon } from "./Generic/AppIcon";
import { IsDefined } from "./Generic/IsDefined";

export interface ClockActionBannerData {
  labelHeader: string;
  labelBody: string;
  buttonString: string;
  visitInstanceId: VisitInstanceId;
  clockTime: LocalDateTime;
  type: "IN" | "OUT";
}

type Props = ClockActionBannerData & { onClick: (details: VisitInstanceId) => void };

export const ClockActionBanner = (props: Props) => {
  return (
    <ClockActionBanner.Root>
      <AppCard onClick={() => props.onClick(props.visitInstanceId)}>
        <ClockActionBanner.Content>
          <div>
            <ClockActionBanner.LabelHeader>
              <span>{props.labelHeader}</span>
              <ClockActionBanner.ClockHour>
                <IsDefined value={props.clockTime}>{(x) => <ClockHour dateTime={x} />}</IsDefined>
              </ClockActionBanner.ClockHour>
            </ClockActionBanner.LabelHeader>
            <ClockActionBanner.LabelBody>{props.labelBody}</ClockActionBanner.LabelBody>
          </div>
          <ClockActionBanner.Button>
            <AppButton variant="filled">
              <AppIcon icon={props.type === "IN" ? PLAY_ICON : SQUARE_ICON} size={16} />
              <ClockActionBanner.ButtonText>{props.buttonString}</ClockActionBanner.ButtonText>
            </AppButton>
          </ClockActionBanner.Button>
        </ClockActionBanner.Content>
      </AppCard>
    </ClockActionBanner.Root>
  );
};

ClockActionBanner.Root = styled.div`
  &.AppCard {
    box-shadow: 0px 5px 15px -6px grey;
    padding: 12px;
  }
`;

ClockActionBanner.Content = styled(AppCardContent)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--primary-color);
  color: #fff;
`;

ClockActionBanner.ButtonText = styled.span`
  margin-inline-start: 6px;
`;

ClockActionBanner.Button = styled.div`
  .AppButton {
    animation: pulse 2s ease infinite;
    background-color: #fff;
    color: var(--primary);

    svg *[fill] {
      fill: var(--primary);
    }
  }
`;

ClockActionBanner.LabelHeader = styled.div`
  font-weight: bold;
  font-size: 17px;
`;

ClockActionBanner.LabelBody = styled.div`
  font-size: 14px;
`;

ClockActionBanner.ClockHour = styled.span`
  margin-inline-start: 5px;
`;
